// extracted by mini-css-extract-plugin
module.exports = {"componentStyle":"OptionLinkCard_componentStyle__WmTAH"};